import { AEMOptions } from "@AEM/models/AEMPage.model"
import { AEMPageType } from "@AEM/models/AEMPage.model"
import { UseQueryResult } from "@tanstack/react-query"
import { useAEMContent } from "./useAEMContent"
import { createItemsArrayMapper } from "@AEM/AEMContentMapper"
import { AEMNotificationItem } from "@AEM/models/AEMResponse.model"

export const useAEMNotificationsData = (options?: AEMOptions) => {
	const { data, isLoading, error, refetch } = useAEMContent(
		AEMPageType.NOTIFICATIONS,
		{ ...options, mapper: createItemsArrayMapper() }
	) as UseQueryResult<AEMNotificationItem[]>

	const notificationsData = data

	return { notificationsData, isLoading, error, refetch }
}
